import { AccessorsMutatorsDecorator, Model } from '../../helpers';

export class GuestReservationHistory extends Model {
    
}

AccessorsMutatorsDecorator(
    'ident',
    'name',
    'name_ar',
    'base_rates',
    'check_in',
    'check_out',
    'total_price',
    'reservation_id'
)(GuestReservationHistory);



// WEBPACK FOOTER //
// ./src/pms-api/models/guest-reservation-history.model.js